// @ts-nocheck
import { CartridgeType } from "./cartridge-type.enum.js";
export class Cartridge {
    static EntryPointOffset = 0x100;
    static TypesWithBatterySave = [
        CartridgeType.ROM_RAM_BATTERY,
        CartridgeType.MBC1_RAM_BATTERY,
        CartridgeType.MBC2_BATTERY,
        CartridgeType.MBC3_RAM_BATTERY,
    ];
    gameDataView;
    gameBytes;
    constructor(gameDataView) {
        this.gameDataView = gameDataView;
        this.gameBytes = new Uint8Array(gameDataView.buffer);
    }
    readByte(address) {
        return this.gameDataView.getUint8(address);
    }
    readSignedByte(address) {
        return this.gameDataView.getInt8(address);
    }
    readWord(address) {
        return this.gameDataView.getUint16(address, true);
    }
    writeByte(address, value) {
        return;
    }
    // ----- MultiNostalgia patches (see ../../PATCHES.md) -----
    //
    // Map a CPU address in the ROM window ($0000-$7FFF) to a flat offset
    // into the cartridge image, accounting for the bank mapped right now.
    // The base cartridge (ROM-only, <=32KB) is a flat 1:1 window. MBC
    // subclasses override to apply banking. Used by GbCoreBase's
    // ExecHookCapable surface (translatePC / write_rom).
    romOffsetForAddress(address) {
        return address & 0xffff;
    }
    // Patch a byte of the in-memory ROM image at a flat offset. Real
    // cartridge ROM is read-only; ours isn't — this is how a Munos script
    // NOPs a branch or swaps an opcode via write_rom. Out-of-range offsets
    // are ignored.
    patchRom(offset, value) {
        if (offset >= 0 && offset < this.gameBytes.length) {
            this.gameDataView.setUint8(offset, value & 0xff);
        }
    }
    writeWord(address, value) {
        return;
    }
    get title() {
        const titleAreaStartOffset = 0x134;
        const titleAreaEndOffset = 0x143;
        const textDecoder = new TextDecoder();
        const titleBytes = this.gameBytes.subarray(titleAreaStartOffset, titleAreaEndOffset);
        return textDecoder.decode(titleBytes);
    }
    get typeName() {
        const typeOffset = 0x147;
        const typeCode = this.gameDataView.getUint8(typeOffset);
        return CartridgeType[typeCode];
    }
    get type() {
        const typeOffset = 0x147;
        return this.gameDataView.getUint8(typeOffset);
    }
    get romSize() {
        const sizeOffset = 0x148;
        const sizeCode = this.gameDataView.getUint8(sizeOffset);
        // MultiNostalgia patch: codes 7 and 8 (4 MiB / 8 MiB) upstream were 4096 /
        // 8192 — decimal-typed-as-hex typos, not powers-of-two of the real size.
        // The MN `romOffsetForAddress` patch folds ROM addresses with
        // `& (this.romSize - 1)`, which requires the true power-of-two size, so a
        // >2 MiB cart would otherwise wrap to a few KiB. No MN GB game hits these
        // codes today (all ≤ 2 MiB), so this is behavior-neutral for current
        // content and correct for future large carts. See PATCHES.md.
        const sizes = [
            0x08000,
            0x010000,
            0x020000,
            0x040000,
            0x080000,
            0x100000,
            0x200000,
            0x400000,
            0x800000,
        ];
        return sizes[sizeCode];
    }
    get ramSize() {
        const sizeOffset = 0x149;
        const sizeCode = this.gameDataView.getUint8(sizeOffset);
        // CAUTION: these values diverge from the GB hardware spec (code 2 = 8 KiB
        // should be 0x2000 not 0x8000; codes 3-5 are decimal-typed-as-hex garbage),
        // but the emulator's MBC logic is CALIBRATED to them — MBC1 gates its 32 KiB
        // RAM-bank path on `ramSize === 0x008000`, and this value also sizes the SRAM
        // ArrayBuffer. Do NOT "correct" these to spec without re-verifying against the
        // actual GB ROMs MultiNostalgia runs (Wario Land, Zelda LA — both MBC1+RAM);
        // changing them is a parity change, not a cleanup. See PATCHES.md.
        const sizes = [
            0,
            0x002000,
            0x008000,
            0x032000,
            0x128000,
            0x512000,
        ];
        return sizes[sizeCode];
    }
    get versionNumber() {
        const versionNumberOffset = 0x14c;
        return this.gameDataView.getUint8(versionNumberOffset);
    }
    get hasSaveableRam() {
        return Cartridge.TypesWithBatterySave.includes(this.type);
    }
}
//# sourceMappingURL=cartridge.js.map